import { render, staticRenderFns } from "./login-page.component.vue?vue&type=template&id=2cc42c44&"
import script from "./login-page.component.ts?vue&type=script&lang=ts&"
export * from "./login-page.component.ts?vue&type=script&lang=ts&"
import style0 from "./login-page.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports